import * as types from '../actions/actionTypes';
import initialState from "./initialState";

export function detailedSchedulesReducer(
  state = initialState.detailedSchedules, action
  ) {
  switch(action.type) {
    case types.FETCH_DETAILED_SCHEDULES_SUCCESS:
      return action.detailedSchedules;
    default:
      return state;
  }
}

export function detailedScheduleParametersReducer(
  state = initialState.detailedScheduleParameters, action
) {
  switch (action.type) {
    case types.EDIT_DETAILED_SCHEDULE_PARAMETERS_SUCCESS:
      return action.parameters;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/detailedScheduleReducer.js